import type React from 'react';
import type { IconProps } from 'types/icon';

const ShieldCheck: React.FC<IconProps> = ({
  size = '24',
  color = 'currentColor',
  ...attributes
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      {...attributes}
    >
      <path
        d="M19.4547 5.69775C19.4547 5.44521 19.2972 5.22403 19.0657 5.14062L19.0183 5.12592L12.6923 3.43422V3.43379C12.2377 3.31324 11.7562 3.3132 11.3016 3.43379L4.97605 5.12592C4.71886 5.19478 4.53966 5.42834 4.53964 5.69775V12.0891C4.53964 14.0574 5.51976 15.899 7.15379 16.9942L11.6708 20.0194L11.7092 20.0428C11.9033 20.1527 12.1399 20.1434 12.3209 20.0207L12.3231 20.0194L16.8406 16.9942L16.841 16.9937C18.4741 15.9033 19.4547 14.0622 19.4547 12.0891V5.69775ZM20.3943 12.0891C20.3943 14.3769 19.2574 16.5138 17.3614 17.7797L12.8444 20.8045L12.8439 20.8041C12.3315 21.1499 11.6629 21.1481 11.1496 20.8045L6.63208 17.7793C4.73697 16.5092 3.59961 14.3728 3.59961 12.0891V5.69775C3.59963 5.00161 4.06474 4.39371 4.73393 4.21454L11.0599 2.52241L11.0608 2.52198C11.635 2.36951 12.24 2.36002 12.8181 2.49343L12.9335 2.52198L12.934 2.52241L19.2604 4.21454C19.9296 4.39374 20.3943 5.00164 20.3943 5.69775V12.0891Z"
        fill={color}
      />
      <path
        d="M14.8327 9.32404C15.0161 9.13985 15.3135 9.13989 15.497 9.32404C15.6804 9.50826 15.6804 9.80681 15.497 9.99103L11.9785 13.5237C11.6949 13.7966 11.2351 13.8066 10.9463 13.5167L9.01845 11.5811C8.83501 11.3969 8.83498 11.0983 9.01845 10.9141C9.20192 10.7299 9.49929 10.7299 9.68276 10.9141L11.4659 12.7044L14.8327 9.32404Z"
        fill={color}
      />
    </svg>
  );
};

export default ShieldCheck;
